import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted, ref } from 'vue'
import { loadStripe, Stripe, StripeCardElement } from '@stripe/stripe-js'
import { Environment } from '@/util/Environment'
import { PaymentCardInfoSubmitResult } from './PaymentCardInfo'


export default /*#__PURE__*/_defineComponent({
  __name: 'StripePaymentCardInfo',
  emits: [
  'change',
],
  setup(__props, { expose: __expose, emit }) {



const useStripe = !!Environment.get('STRIPE_PUBLIC_KEY') // use Stripe if configured

let stripe: Stripe | null
let stripeCard: StripeCardElement | null
const stripeElemRef = ref<HTMLElement>()
const readyRef = ref(false)

__expose({
  ready: readyRef,
  submitAsync,
})

onMounted(async () => {
  if (useStripe) {
    stripe = await loadStripe(Environment.get('STRIPE_PUBLIC_KEY'))
    if (!stripe)
      throw 'Failed to load payment provider'

    const elements = stripe.elements()
    stripeCard = elements.create('card')
    stripeCard.mount(stripeElemRef.value!)
    stripeCard.on('change', e => emit('change', e))

    readyRef.value = true    
  }
})

onUnmounted(() => {
  stripeCard?.destroy()
})

async function submitAsync(intentId: string, clientSecret: string): Promise<PaymentCardInfoSubmitResult> {
  if (!readyRef.value)
    return { error: { message: 'Payment provider not ready' } }

  const result = await stripe!.confirmCardPayment(
    clientSecret, { payment_method: { card: stripeCard! } })
  
  return result
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "stripeElemRef",
    ref: stripeElemRef
  }, null, 512))
}
}

})